import React, { useEffect, useState, useContext } from "react";
import { jwtDecode } from "jwt-decode";
import dayjs from "dayjs";
import {
  Box,
  Chip,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import Designs from "./Designs";
import DesignMesAcumulado from "./DesignsMesAcumulado";
import { SidebarContext } from "../Sidebar/SidebarProvider";
import {
  pageHeroShellSx,
  pageFieldSx,
  pageSectionTitleSx,
  pageKpiChipSx,
} from "../../styles/pageModernStyles";

const DashboardDesignPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { contentMargin } = useContext(SidebarContext);

  const [hasPermission, setHasPermission] = useState(false);
  const [year, setYear] = useState(dayjs().year());

  const pageShellSx = {
    ...contentMargin,
    p: { xs: 1, sm: 2 },
    pb: { xs: 10, sm: 3 },
    minHeight: "100vh",
    boxSizing: "border-box",
  };

  useEffect(() => {
    try {
      const token = localStorage.getItem("token");
      const decoded = jwtDecode(token);

      if (decoded.Permiso_DashboardDesigns) {
        setHasPermission(true);
      }
    } catch (err) {
      console.error("❌ Error cargando permisos:", err);
    }
  }, []);

  return (
    <Box sx={pageShellSx}>
      <Box sx={pageHeroShellSx(theme, { sticky: isMobile })}>
        <Stack
          direction={{ xs: "column", lg: "row" }}
          alignItems={{ xs: "flex-start", lg: "center" }}
          justifyContent="space-between"
          spacing={2}
          sx={{ px: { xs: 1.5, sm: 2.5 }, py: { xs: 1.5, sm: 2 } }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: 2,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: alpha(theme.palette.secondary?.main || theme.palette.primary.main, 0.14),
                color: "secondary.main",
                flexShrink: 0,
              }}
            >
              <PaletteOutlinedIcon />
            </Box>
            <Box>
              <Typography sx={pageSectionTitleSx}>Diseño · Dashboard</Typography>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 900,
                  lineHeight: 1.2,
                  fontSize: { xs: "1.15rem", sm: "1.4rem" },
                }}
              >
                Panel de diseños
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                Productos creados por diseñador, mes a mes.
              </Typography>
            </Box>
          </Stack>

          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            sx={{ width: { xs: "100%", lg: "auto" } }}
          >
            <Chip label={String(year)} size="small" variant="outlined" sx={pageKpiChipSx} />
            <TextField
              select
              size="small"
              label="Año"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              sx={{ ...pageFieldSx(theme), minWidth: { sm: 110 }, flex: 1 }}
              InputProps={{
                startAdornment: (
                  <CalendarMonthOutlinedIcon
                    fontSize="small"
                    sx={{ color: "text.secondary", mr: 0.5 }}
                  />
                ),
              }}
            >
              {[...Array(6)].map((_, i) => {
                const y = dayjs().year() - i;
                return (
                  <MenuItem key={y} value={y}>
                    {y}
                  </MenuItem>
                );
              })}
            </TextField>
          </Stack>
        </Stack>
      </Box>

      <Grid container spacing={2} sx={{ mt: 0.5 }}>
        <Grid item xs={12} md={6}>
          <Designs year={year} />
        </Grid>
        <Grid item xs={12} md={6}>
          <DesignMesAcumulado year={year} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default DashboardDesignPage;
